module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAaCAYAAABsONZfAAAAAXNSR0IArs4c6QAAAJVJREFUOE/tlDEOwjAMRe0MnYEDlhu0LLB+e+1Ee4ReMMwMMSoEKUSy1JEhWazo68my/fUZQBdCmIiop89bU0o3VX16GqvqnYjGDHzLDODiaRsUiehQQQ8AR0/zoAjg5ECRRWRm5qHsZGaLiIyexsWw5w00s9XMrtUifjSuZtn1/XeoOeJ9/KU5Itu5XETLiByWuzPiBf7W5ELQIumIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/drag-icon.png
// module id = 8E5g
// module chunks = 96